/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  Botao,
  Breadcrumb,
  Cabecalho,
  Cores,
  Filtro,
  IconeDeListaDeDocumentos,
  IconeCheckPequeno,
  IconeRevelarSenha,
  InputUnform,
  SelectUnform,
  Tooltip,
  DataInputUnform
} from 'src/componentes'
import {
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta
} from 'src/componentes/tabela'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'
import {
  RotasAlunoCertificacao,
  RotasCertificacaoInstitucional,
  RotasParceiroCertificacao,
  RotasProfessorCertificacao
} from 'src/rotas'
import { Api } from 'src/servicos'
import {
  CategoriaTicketParceiroCertificacaoPorExtenso,
  TipoOrdenacao
} from 'src/tipos'

import {
  FinalizarTicket,
  ModalFinalizarTicket,
  ModalFinalizarTicketRef
} from './componentes'
import {
  Form,
  Container,
  Campo,
  Dados,
  ContainerAcoes,
  IconeAcao
} from './styles'

interface DadosPesquisa {
  nomeAluno?: string
  nomeTurma?: string
  categoria?: string
  status?: string
  tipo?: string
  dataCriacaoInicio?: string
  dataCriacaoFim?: string
}

export const PaginaFilasTrabalhoInstituicao: React.FC = () => {
  const tabelaRef = useRef<TabelaRef>()
  const modalFinalizarTicket = useRef<ModalFinalizarTicketRef>(null)
  const [dadosPesquisa, definirDadosPesquisa] = useState<DadosPesquisa>({})
  const [paginas, definirPaginas] = useState(null)
  const history = useHistory()

  const acaoPesquisa = (dados: DadosPesquisa) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }

    definirDadosPesquisa(dados)
  }

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }

    const dados = await Api.ObterTicketsParceiroCertificacaoFilaTrabalho({
      nomeAluno: dadosPesquisa?.nomeAluno,
      nomeTurma: dadosPesquisa?.nomeTurma,
      categoria: dadosPesquisa?.categoria,
      status: dadosPesquisa?.status,
      tipo: dadosPesquisa?.tipo,
      dataCriacaoInicio: dadosPesquisa?.dataCriacaoInicio,
      dataCriacaoFim: dadosPesquisa?.dataCriacaoFim,
      pagina: numeroPaginas,
      tamanhoPagina: quantidadePorPagina
    })

    if (!dados) return null

    definirPaginas(null)

    const quantidade = dados.quantidade ?? (dados as any).Quantidade ?? 0
    const itens = dados.itens ?? (dados as any).Itens ?? []

    return {
      Dados: itens,
      Paginacao: {
        Pagina: numeroPaginas,
        TotalRegistros: quantidade
      }
    } as TabelaResposta
  }

  const finalizarTicket = async (dados: FinalizarTicket) => {
    try {
      await Api.FinalizarTicketParceiroCertificacao(dados.idTicket, dados.observacao)
      tabelaRef.current?.CarregarDados()
      toast('Ticket finalizado com sucesso!', { type: 'success' })
    } catch {
      toast('Erro ao finalizar ticket.', { type: 'error' })
    }
  }

  const resolverRotaDocumento = (linha: TabelaDados): string => {
    if (linha.categoria === 'DocumentacaoAlunoCertificacao') {
      if (!linha.alunoId) return RotasCertificacaoInstitucional.FilasTrabalho
      return `${RotasAlunoCertificacao.Documentos}/${linha.alunoId}`
    }

    if (linha.categoria === 'DocumentacaoProfessorCertificacao') {
      if (!linha.professorId) return RotasCertificacaoInstitucional.FilasTrabalho
      return `${RotasProfessorCertificacao.Documentos}/${linha.professorId}`
    }

    if (linha.categoria === 'DocumentacaoParceiroCertificacao') {
      if (linha.turmaId) {
        return `${RotasParceiroCertificacao.Documentos}/turma/${linha.turmaId}`
      }

      if (!linha.parceiroId) return RotasCertificacaoInstitucional.FilasTrabalho
      return `${RotasParceiroCertificacao.Documentos}/parceiro/${linha.parceiroId}`
    }

    return RotasCertificacaoInstitucional.FilasTrabalho
  }

  const abrirDocumentosEmNovaAba = (rota: string): void => {
    if (rota === RotasCertificacaoInstitucional.FilasTrabalho) return

    const novaAba = window.open(rota)
    novaAba?.focus()
  }

  const acaoDocumentos = (linha: TabelaDados): void => {
    const rotaDocumento = resolverRotaDocumento(linha)

    if (rotaDocumento !== RotasCertificacaoInstitucional.FilasTrabalho) {
      history.push(rotaDocumento)
    }
  }

  const resolverTooltipDocumento = (categoria: string): string => {
    if (categoria === 'DocumentacaoAlunoCertificacao') {
      return 'Ver documentos do aluno'
    }

    if (categoria === 'DocumentacaoProfessorCertificacao') {
      return 'Ver documentos do professor'
    }

    if (categoria === 'DocumentacaoParceiroCertificacao') {
      return 'Ver documentos do parceiro'
    }

    return 'Ver documentos'
  }

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  return (
    <>
      <Cabecalho>
        <Breadcrumb
          titulo="Filas de Trabalho"
          atalhos={[
            {
              texto: 'Certificação institucional'
            },
            {
              texto: 'Filas de Trabalho'
            }
          ]}
        />
      </Cabecalho>
      <Filtro>
        <Form
          dadosIniciais={{}}
          acaoSucesso={acaoPesquisa}
        >
          <Container>
            <Campo mr>
              <InputUnform
                type="text"
                name="nomeAluno"
                label="Nome do Usuário"
                maxLength={200}
              />
            </Campo>
            <Campo mr>
              <InputUnform
                type="text"
                name="nomeTurma"
                label="Turma"
                maxLength={200}
              />
            </Campo>
            <Campo>
              <SelectUnform
                id="slct_categoria"
                name="categoria"
                label="Categoria"
                iconeFechar
                opcoes={[
                  {
                    id: 'DocumentacaoParceiroCertificacao',
                    texto: 'Documentação Parceiro Certificação'
                  },
                  {
                    id: 'DocumentacaoProfessorCertificacao',
                    texto: 'Documentação Professor Certificação'
                  },
                  {
                    id: 'DocumentacaoAlunoCertificacao',
                    texto: 'Documentação Aluno Certificação'
                  }
                ]}
              />
            </Campo>
          </Container>
          <Container>
            <Campo mr>
              <SelectUnform
                id="slct_status"
                name="status"
                label="Status"
                iconeFechar
                opcoes={[
                  {
                    id: 'Pendente',
                    texto: 'Pendente'
                  },
                  {
                    id: 'Concluido',
                    texto: 'Concluído'
                  }
                ]}
              />
            </Campo>
            <Campo mr>
              <SelectUnform
                id="slct_tipo"
                name="tipo"
                label="Tipo"
                iconeFechar
                opcoes={[
                  {
                    id: 'Solicitacao',
                    texto: 'Solicitação'
                  }
                ]}
              />
            </Campo>
            <Campo mr>
              <DataInputUnform
                name="dataCriacaoInicio"
                label="Data abertura de Ticket" 
              />
            </Campo>
            <Campo>
              <DataInputUnform name="dataCriacaoFim" label="Data fechamento de ticket" />
            </Campo>
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <Tabela
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'numeroProtocolo',
              ComOrdenacao: true,
              RenderizarCabecalho: () => <div style={{ width: 130 }}>Protocolo</div>
            },
            {
              Chave: 'nomeAluno',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <>{linha.nomeAluno || linha.nomeUsuario || 'N/A'}</>
              ),
              RenderizarCabecalho: () => <div style={{ width: 150 }}>Nome</div>
            },
            {
              Chave: 'tipo',
              ComOrdenacao: true,
              RenderizarCabecalho: () => <div style={{ width: 100 }}>Tipo</div>
            },
            {
              Chave: 'categoria',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <>
                  {CategoriaTicketParceiroCertificacaoPorExtenso[linha.categoria] ??
                    linha.categoria}
                </>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 120 }}>Categoria</div>
              )
            },
            {
              Chave: 'status',
              ComOrdenacao: true,
              RenderizarCabecalho: () => <div style={{ width: 100 }}>Status</div>
            },
            {
              Chave: 'dataCriacao',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <span>
                  {formatadores.dataHoraLocaleString(linha.dataCriacao)}
                </span>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 120 }}>Data Criação</div>
              )
            },
            {
              Chave: 'dataAtualizacao',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <span>
                  {linha.dataAtualizacao ? formatadores.dataHoraLocaleString(linha.dataAtualizacao) : 'N/A'}
                </span>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 130 }}>Data Atualização</div>
              )
            },
            {
              Chave: 'acoes',
              RenderizarCabecalho: () => <div>Ações</div>,
              Renderizar: (linha: TabelaDados) => {
                const LISTA_DOCUMENTOS_ID = `LISTA_DOCUMENTOS_ID/${linha.id}`
                const TICKET_LOG_ID = `TICKET_LOG_ID/${linha.id}`
                const FINALIZAR_TICKET_ID = `FINALIZAR_TICKET_ID/${linha.id}`

                return (
                  <ContainerAcoes>
                    <IconeAcao
                      onClick={() => acaoDocumentos(linha)}
                      onContextMenu={evento => {
                        evento.preventDefault()
                        abrirDocumentosEmNovaAba(resolverRotaDocumento(linha))
                      }}
                      data-tip={resolverTooltipDocumento(linha.categoria)}
                      data-for={LISTA_DOCUMENTOS_ID}
                    >
                      {IconeDeListaDeDocumentos}
                      <Tooltip
                        id={LISTA_DOCUMENTOS_ID}
                        textColor={Cores.PRETO}
                        backgroundColor={Cores.CINZA_1_CLARO}
                        place="right"
                      />
                    </IconeAcao>
                    <IconeAcao
                      onClick={() => {
                        const caminho = RotasCertificacaoInstitucional.HistoricoTicket
                        const rota = `${caminho}/${linha.id}`
                        history.push(rota)
                      }}
                      onContextMenu={() => {
                        const caminho = RotasCertificacaoInstitucional.HistoricoTicket
                        const rota = window.open(`${caminho}/${linha.id}`)
                        rota.focus()
                      }}
                      data-tip="Ver histórico do ticket"
                      data-for={TICKET_LOG_ID}
                    >
                      {IconeRevelarSenha}
                      <Tooltip
                        id={TICKET_LOG_ID}
                        textColor={Cores.PRETO}
                        backgroundColor={Cores.CINZA_1_CLARO}
                        place="right"
                      />
                    </IconeAcao>
                    {linha.status !== 'Concluido' && (
                      <IconeAcao
                        onClick={() => modalFinalizarTicket.current?.abrir(linha.id)}
                        data-tip="Finalizar ticket"
                        data-for={FINALIZAR_TICKET_ID}
                      >
                        {IconeCheckPequeno}
                        <Tooltip
                          id={FINALIZAR_TICKET_ID}
                          textColor={Cores.PRETO}
                          backgroundColor={Cores.CINZA_1_CLARO}
                          place="right"
                        />
                      </IconeAcao>
                    )}
                  </ContainerAcoes>
                )
              }
            }
          ]}
          ComPaginacao
          ObterDados={obterDados}
        />
      </Dados>
      <ModalFinalizarTicket
        ref={modalFinalizarTicket}
        acaoPrimaria={finalizarTicket}
      />
    </>
  )
}

export * from './historico'
